import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";

const createTeam = createAsyncThunk(
  "team/createTeam",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.post("/teams", JSON.stringify(data), {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const getAllTeams = createAsyncThunk(
  "team/getAllTeams",
  async (_, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.get("/teams", {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const getTeam = createAsyncThunk(
  "team/getTeam",
  async (teamId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.get(`/teams/${teamId}`, {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const updateTeam = createAsyncThunk(
  "team/updateTeam",
  async ({ teamId, data }, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.patch(
        `/teams/${teamId}`,
        JSON.stringify(data),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const deleteTeam = createAsyncThunk(
  "team/deleteTeam",
  async (teamId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.delete(`/teams/${teamId}`, {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const assignUserToTeam = createAsyncThunk(
  "team/assignUserToTeam",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.post(
        "/teams/assign-user",
        JSON.stringify(data),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const updateUserTeamRole = createAsyncThunk(
  "team/updateUserTeamRole",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.patch(
        "/teams/update-user-role",
        JSON.stringify(data),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

export {
  createTeam,
  getAllTeams,
  getTeam,
  updateTeam,
  deleteTeam,
  assignUserToTeam,
  updateUserTeamRole,
};





